import { setWindowLocation } from '@eb/http';

export const handleRedirect = (url) => () => setWindowLocation(url);
